<div class="container_qr" *ngIf="isStart">
  <div class="content_qr">
    <div style="text-align: center;margin-top: 100px;">
      <div>
        <button id="{{elementIds.scanner_camera}}" [disabled]="action.isLoading"
          class="button_icon button_icon_color scanner_camera" (click)=" toggleScanner(action)"
          [ngClass]="action.isStart ? 'camera_on' : ''">cancel</button>
      </div>
      <div id="{{elementIds.scanner_area}}" class="camera_area"
        [ngClass]="action.isStart ? 'scanner_on' : 'scanner_off'" style="margin-left: calc(50% - 150px);">
        <div class="camera_actions">
          <div class="row">
            <div class="col-4">
              <button class="button_icon" [disabled]="!this.mediaDevice || this.mediaDevice.length < 2"
                (click)="onAction(1)">cameraswitch</button>
            </div>
            <div class="col-4">
              <button class="button_icon" *ngIf="!action.isTorch"
                (click)="action.isTorch = !action.isTorch; handle(action, 'torcher')">flash_off</button>
              <button class="button_icon" *ngIf="action.isTorch"
                (click)="action.isTorch = !action.isTorch; handle(action, 'torcher');">flash_on</button>
            </div>
            <div class="col-4">
              <input #file type="file" *ngIf="action.isStart" (change)="onSelects(file.files)"
                [accept]="'.jpg, .png, .gif, .jpeg'" />
            </div>
          </div>
        </div>
        <ngx-scanner-qrcode #action="scanner" [config]="config" (event)="onScanned($event)"></ngx-scanner-qrcode>
        <div *ngFor="let item of qrCodeResult" class="scanned_images">
          <ngx-scanner-qrcode #actionFile="scanner" [src]="item.url" [config]="config"
            (event)="onScanned($event)"></ngx-scanner-qrcode>
          <!-- <p class="data">{{ actionFile.data | async }}</p> -->
        </div>
      </div>
    </div>
  </div>
</div>